import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'regNo'
})
export class RegNoPipe implements PipeTransform {

  transform(value: string, obj: any): string {
      let result=[];
        obj.filter((element)=>{
          if (element['vehicleID']==value){
            result.push(element);
          }
        })
      if (result && result.length>0 ) return result[0].vehRegNo;
      else return '---';
  }
}
